import { render, staticRenderFns } from "./pannel-data.vue?vue&type=template&id=71133b48&scoped=true&"
import script from "./pannel-data.vue?vue&type=script&lang=js&"
export * from "./pannel-data.vue?vue&type=script&lang=js&"
import style0 from "./pannel-data.vue?vue&type=style&index=0&id=71133b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71133b48",
  null
  
)

export default component.exports